import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'

export default {
  data() {
    return { queryAll: false, planRequestId: 0 }
  },
  computed: {
    isAdmin() {
      const user = this.$store.getters.userInfo
      return !!user && user.username === 'admin'
    }
  },
  beforeDestroy() {
    this.planRequestId++
  },
  methods: {
    getQueryParams() {
      return { ...JeecgListMixin.methods.getQueryParams.call(this), queryAll: this.isAdmin && this.queryAll }
    },
    changeQueryAll(checked) {
      this.queryAll = checked
      this.dataSource = []
      this.ipagination.total = 0
      this.onClearSelected()
      this.loadData(1)
    },
    initTableData(arg) {
      if (arg === 1) this.ipagination.current = 1
      const requestId = ++this.planRequestId
      this.loading = true
      // 范围切换后只接受最新请求，避免旧的全部数据重新显示。
      return getAction(this.pagePath, this.getQueryParams()).then(res => {
        if (requestId !== this.planRequestId) return
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
          this.loadNums++
        } else {
          this.$message.warning('系统异常=>' + res.message)
        }
      }).catch(() => {
        if (requestId === this.planRequestId) this.$message.warning('计划加载失败，请重试')
      }).finally(() => {
        if (requestId === this.planRequestId) this.loading = false
      })
    }
  }
}
